import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { SectorModel } from '../../models/sector.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SectorService extends BaseService<SectorModel> {

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Sector';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.sector}`;
   }
}
